// GENERATED by scripts/build-icons.mjs from icons/building-2.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Building2 = createIcon('building-2', [
  ['path', { d: "M10 12h4" }],
  ['path', { d: "M10 8h4" }],
  ['path', { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
  ['path', { d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" }],
  ['path', { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" }],
])
